module.exports = __webpack_public_path__ + "static/P2101532-48a73b4c4a9643ffa4ab654700c6e5bd.jpg";